export default {
	state: {
		emailCadastro: {}
	},
	getters: {
		"emailCadastro": state => state.emailCadastro
	},
	mutations: {
		setEmailCadastro(state, payload) {
			state.emailCadastro = payload
		}
	},
	actions: {
		atualizarEstadoEmailCadastro({ commit }, payload) {
			commit('setEmailCadastro', payload)
		}
	}
};